import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const DiscordIntegration = React.lazy(() => import("./DiscordIntegration"));

interface DiscordIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
  brandTheme?: string | null;
}

export default function DiscordIntegrationLazy(props: DiscordIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <DiscordIntegration {...props} />
    </Suspense>
  );
}
